import React, { Component } from "react";
import { getCall } from "../../../api/post";
import {
  getImageUrl,
  getPlaceHolderImage,
  getSettingUrl,
  getMerchantInformationUrl,
  getPaymentDetailsUrl,
  getMasterDetailsIdUrl,
  getAddressDetailUrl,
} from "../../../services";
import { connect } from "react-redux";
import Moment from "react-moment";
import {
  getCommonCounter,
  getNotificationCounter,
  isInquiryOrCart,
} from "../../../actions";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  getColorCodeBasedOnKey,
  formatPrice,
} from "../../../store";
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import RightTickMarkAnim from "../../../animation/RightTickMarkAnim";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import Lightbox from "react-image-lightbox";

class OrderDetails extends Component {
  state = {
    items: [],
    orderId: this.props.match.params.id,
    inquiryId: this.props.match.params.id,
    orderSummary: {},
    inquirySummary: {},
    isLoading: true,
    isMerchantGSTEnable: false,
    merchantInfo: {},
    paymentDetails: [],
    currentCatelogueType: {},
    showErrorMessageModal: false,
    errorMessage: "",
    masterDetailsObj: {},
    isFullScreenImage: false,
    fullScreenImagePath: "",
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    if (isOpenStoreIdExist()) {
      navigateTo(this.props, `/`);
      return;
    }
    this.initMasterDetailsId().then(() => {
      const { masterDetailsObj } = this.state;
      this.props.isInquiryOrCart(masterDetailsObj);
      this.initOrderSummary().then(() => {
        this.setState({ isLoading: false });
      });

      this.initMerchantInfo();
      this.initPaymentDetails();
      this.initCatelogueSettings();
      this.props.counter();
      this.props.notificationCounter();
      this.props.isInquiryOrCart(masterDetailsObj);
      this.initAddressDetails();
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initOrderSummary = async () => {
    const { orderId } = this.state;

    const orderSummaryUrl = `v2/orders/${orderId}`;
    const orderSummary = await getCall(orderSummaryUrl, []);

    if (orderSummary.error) {
      clearLocalStorageReload({ response: orderSummary });
      this.loadErrorMessageAnimation(orderSummary.error.message);
      if (orderSummary.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ orderSummary });
    }
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({ isMerchantGSTEnable: false, merchantInfo: {} });
    } else {
      this.setState({
        merchantInfo,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initPaymentDetails = async () => {
    const { masterDetailsObj } = this.state;
    const paymentDetailsUrl = getPaymentDetailsUrl(masterDetailsObj);
    const paymentDetails = await getCall(paymentDetailsUrl, []);
    if (paymentDetails.error) {
      clearLocalStorageReload({ response: paymentDetails });
      this.loadErrorMessageAnimation(paymentDetails.error.message);
    } else {
      this.setState({ paymentDetails });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      this.setState({ currentCatelogueType: settings });
    }
  };

  initAddressDetails = async () => {
    const { masterDetailsObj } = this.state;
    const addressDetails = await getCall(
      getAddressDetailUrl(masterDetailsObj),
      []
    );

    if (addressDetails.error) {
      clearLocalStorageReload({ response: addressDetails });
    } else {
      if (addressDetails.length > 0) {
        this.setState({ addressDetails: JSON.parse(addressDetails[0].text) });
      }
    }
  };

  getTotalofCart(orderSummary) {
    let total = 0;
    if (orderSummary.orderdetail)
      for (let i = 0; i < orderSummary.orderdetail.length; i++) {
        total =
          total +
          orderSummary.orderdetail[i].amount *
            orderSummary.orderdetail[i].quantity;
      }
    return total;
  }

  getSubTotalFromTotalandServiceCharges = () => {
    const { orderSummary } = this.state || {};
    let subTotal = 0;
    const total = this.getTotalofCart(orderSummary);
    const serviceChargeAmount = parseFloat(this.renderServiceCharges());
    subTotal = total + serviceChargeAmount;
    return subTotal;
  };

  getCGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.CGST) / 100;
  };
  getSGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.SGST) / 100;
  };

  getIGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.IGST) / 100;
  };

  getGrandTotal = (total, cgst, sgst, igst, shippingCharges) => {
    const { merchantInfo, currentCatelogueType } = this.state;
    var grandTotal = 0;
    if (merchantInfo.enablegst === 0) {
      grandTotal = total + shippingCharges;

      return grandTotal;
    }
    if (
      merchantInfo.enablegst === 1 &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      grandTotal = total + shippingCharges;

      return grandTotal;
    }
    if (merchantInfo.countryname === "India") {
      grandTotal = total + cgst + sgst + shippingCharges;
    } else {
      grandTotal = total + igst + shippingCharges;
    }

    return grandTotal;
  };

  // Update renderBillingAddress to handle array structure from response
  renderBillingAddress = () => {
    const { orderSummary } = this.state;
    if (
      orderSummary &&
      orderSummary.address
    ) {
      let addressObj = {};
      try {
        addressObj = JSON.parse(orderSummary.address);
      } catch (e) {
        return null;
      }
      const billingArr = addressObj.billingaddress || [];
      if (billingArr.length === 0) return null;
      const billingAddress = billingArr[0];
      return (
        <ul className="order-detail">
          <li><b>Name:</b> {billingAddress.name}</li>
          <li><b>Mobile:</b> {billingAddress.phone}</li>
          <li><b>Address:</b> {billingAddress.addressline1}, {billingAddress.addressline2}</li>
          <li><b>City:</b> {billingAddress.city}</li>
          <li><b>State:</b> {billingAddress.state}</li>
          <li><b>Country:</b> {billingAddress.country}</li>
          <li><b>Zipcode:</b> {billingAddress.zipcode}</li>
        </ul>
      );
    }
    return null;
  };

  // Update renderShippingAddress to handle array structure from response
  renderShippingAddress = () => {
    const { orderSummary } = this.state;
    if (orderSummary && orderSummary.address) {
      let addressObj = {};
      try {
        addressObj = JSON.parse(orderSummary.address);
      } catch (e) {
        return null;
      }
      const shippingArr = addressObj.shippingaddress || [];
      if (shippingArr.length === 0) return null;
      const shippingAddress = shippingArr[0];
      return (
        <ul className="order-detail">
          <li><b>Name:</b> {shippingAddress.name}</li>
          <li><b>Mobile:</b> {shippingAddress.phone}</li>
          <li><b>Address:</b> {shippingAddress.addressline1}, {shippingAddress.addressline2}</li>
          <li><b>City:</b> {shippingAddress.city}</li>
          <li><b>State:</b> {shippingAddress.state}</li>
          <li><b>Country:</b> {shippingAddress.country}</li>
          <li><b>Zipcode:</b> {shippingAddress.zipcode}</li>
        </ul>
      );
    }
    return null;
  };

  renderPriceBreakdownSJ = (other) => {
    const jwelleryData = JSON.parse(other);
    if (jwelleryData.jewelleryData) {
      return (
        <div className="col-12" style={{ textAlign: "end" }}>
          <h4>Price Breakdown</h4>
          <p>
            {jwelleryData.jewelleryData.name} :{" "}
            {jwelleryData.jewelleryData.weightintoprice}
          </p>
          {jwelleryData.jewelleryData.makingcharges &&
            jwelleryData.jewelleryData.makingcharges.map((makingcharge) => {
              return (
                <p>
                  {makingcharge.pricelable} : {makingcharge.amount}
                </p>
              );
            })}
        </div>
      );
    } else {
      return <div />;
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  renderPaymentStatus = (paymentstatus) => {
    const strPaymentStatus = getValueFromLanguageObject("str_payment_status")
      ? getValueFromLanguageObject("str_payment_status")
      : "Payment Status";
    const paymentStatus =
      paymentstatus === 1
        ? "PENDING"
        : paymentstatus === 2
        ? "SUCCESS"
        : "FAILED";
    return <li>{`${strPaymentStatus}: ${paymentStatus}`}</li>;
  };

  renderServiceChargesLabel = () => {
    let labelServiceCharges = "";
    const { orderSummary } = this.state || {};
    const { additionalchargedetails } = orderSummary || {};
    if (additionalchargedetails) {
      const additionalchargedetailsObj =
        JSON.parse(additionalchargedetails) || {};
      const { label = "" } = additionalchargedetailsObj || {};
      labelServiceCharges = label;
    }
    return labelServiceCharges;
  };

  renderServiceCharges = () => {
    let serviceCharges = 0;
    const { orderSummary } = this.state || {};
    const { additionalchargedetails } = orderSummary || {};
    if (additionalchargedetails) {
      const additionalchargedetailsObj =
        JSON.parse(additionalchargedetails) || {};
      const { charges = 0 } = additionalchargedetailsObj || {};
      serviceCharges = formatPrice(charges);
    }
    return serviceCharges;
  };

  render() {
    const {
      orderSummary,
      isLoading,
      isMerchantGSTEnable,
      currentCatelogueType,
      showErrorMessageModal,
      errorMessage,
      masterDetailsObj,
      isFullScreenImage,
      fullScreenImagePath,
    } = this.state;
    const { symbol, isInquiry } = this.props;

    const subTotal = this.getSubTotalFromTotalandServiceCharges();

    return (
      <div>
        <section className="section-b-space light-layout">
          <div className="container" style={{ marginTop: "80px" }}>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="success-text text-center">
                  <RightTickMarkAnim />
                  <h2 className="mb-3">
                    {getValueFromLanguageObject("str_thank_you")
                      ? getValueFromLanguageObject("str_thank_you")
                      : "Thank you"}
                  </h2>
                  <p className="lead">
                    {!isInquiry
                      ? getValueFromLanguageObject("str_order_placed_successfully")
                        ? getValueFromLanguageObject("str_order_placed_successfully")
                        : "Order Placed Successfully"
                      : getValueFromLanguageObject("str_inquiry_placed_successfully")
                        ? getValueFromLanguageObject("str_inquiry_placed_successfully")
                        : "Inquiry Placed Successfully"}
                  </p>
                  <p>
                    {!isInquiry
                      ? getValueFromLanguageObject("order_id")
                        ? getValueFromLanguageObject("order_id")
                        : "Order ID"
                      : getValueFromLanguageObject("str_inquiry_no_")
                        ? getValueFromLanguageObject("str_inquiry_no_")
                        : "Inquiry ID"}
                    : <b>{orderSummary.orderno}</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="product-order order-success-sec">
                  <h4 className="f22 mb-4">
                    {!isInquiry
                      ? getValueFromLanguageObject("str_your_order_details")
                        ? getValueFromLanguageObject("str_your_order_details")
                        : "Your order details"
                      : getValueFromLanguageObject("str_your_inquiry_details")
                        ? getValueFromLanguageObject("str_your_inquiry_details")
                        : "Your inquiry details"}
                  </h4>
                  {orderSummary.orderdetail &&
                    orderSummary.orderdetail.map((item, index) => (
                      <div className="row product-order-detail align-items-center mb-3" key={index}>
                        <div
                          className="col-12 col-sm-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const path =
                              item.products.productmedia &&
                              item.products.productmedia.length > 0
                                ? getImageUrl(
                                    item.products.productmedia[0].productname,
                                    masterDetailsObj
                                  )
                                : getPlaceHolderImage();
                            this.setState({
                              isFullScreenImage: true,
                              fullScreenImagePath: path,
                            });
                          }}
                        >
                          <img
                            src={
                              item.products.productmedia &&
                              item.products.productmedia.length > 0
                                ? getImageUrl(
                                    item.products.productmedia[0].productname,
                                    masterDetailsObj
                                  )
                                : getPlaceHolderImage()
                            }
                            alt=""
                            className="img-fluid rounded"
                            style={{ maxHeight: 80, objectFit: "cover" }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = getPlaceHolderImage();
                            }}
                          />
                        </div>
                        <div className="col-12 col-sm-4 order_detail" style={{ display: "flex", flexDirection: "column" }}>
                          <h5 className="mb-1" style={{ marginBottom: "4px" }}>{item.products.name}</h5>
                          <div className="text-muted" style={{ marginBottom: "4px" }}>
                            {item.products.category && item.products.category.name}
                          </div>
                        </div>
                        <div className="col-6 col-sm-3 order_detail">
                          <div>
                            <span className="text-muted">Quantity:</span>
                            <span className="ml-2">{item.quantity}</span>
                          </div>
                        </div>
                        {!isInquiry && (
                          <div className="col-6 col-sm-3 order_detail">
                            <div>
                              <span className="text-muted">Price:</span>
                              <span className="ml-2">{formatPrice(item.amount)}</span>
                            </div>
                          </div>
                        )}
                        {currentCatelogueType &&
                          currentCatelogueType.registerallow ===
                            "Catalogue_Jewellary" &&
                          item.products.other &&
                          item.products.other &&
                          this.renderPriceBreakdownSJ(item.products.other)}
                      </div>
                    ))}
                  {!isInquiry && (
                    <div className="total-sec mt-4">
                      <div className="final-total">
                        <h4>
                          {getValueFromLanguageObject("str_total")
                            ? getValueFromLanguageObject("str_total")
                            : "Total"}
                          <span className="ml-2">
                            {formatPrice(this.getTotalofCart(orderSummary))}
                          </span>
                        </h4>
                        {/* <h4>
                          {`+ ${getValueFromLanguageObject("shipping_charges")
                            ? getValueFromLanguageObject("shipping_charges")
                            : "Shipping Charges"}`}
                          <span className="ml-2">
                            {formatPrice(orderSummary.shippingprice || 0)}
                          </span>
                        </h4> */}
                        {/* <h4>
                          {`- ${getValueFromLanguageObject("discount")
                            ? getValueFromLanguageObject("discount")
                            : "Discount"}`}
                          <span className="ml-2">{formatPrice(0)}</span>
                        </h4> */}
                        {/* <h4>
                          {getValueFromLanguageObject("amount_payable")
                            ? getValueFromLanguageObject("amount_payable")
                            : "Amount Payable"}
                          <span className="ml-2">
                            {formatPrice(
                              this.getGrandTotal(
                                subTotal,
                                0,
                                0,
                                0,
                                orderSummary.shippingprice
                              )
                            )}
                          </span>
                        </h4> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
                  <div className="col-lg-12 mt-4">
                <div className="row order-success-sec">
                  <div className="col-lg-12 mb-4">
                    <h4 className="f22 mb-2">
                      {getValueFromLanguageObject("str_customer_detail")
                        ? getValueFromLanguageObject("str_customer_detail")
                        : "Customer Details"}
                    </h4>
                    <ul className="order-detail">
                      <li>
                        <b>Name:</b>{" "}
                        {orderSummary.orderuser &&
                          (orderSummary.orderuser.firstname
                            ? orderSummary.orderuser.firstname + " " + orderSummary.orderuser.lastname
                            : orderSummary.orderuser.username)}
                      </li>
                      <li>
                        <b>Mobile:</b>{" "}
                        {orderSummary.orderuser &&
                          orderSummary.orderuser.cellnumber}
                      </li>
                      <li>
                        <b>Email:</b>{" "}
                        {orderSummary.orderuser &&
                          orderSummary.orderuser.email}
                      </li>
                      {orderSummary.orderuser &&
                        orderSummary.orderuser.agentcode && (
                          <li>
                            <b>Agent Code:</b> {orderSummary.orderuser.agentcode}
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {isFullScreenImage && (
          <Lightbox
            mainSrc={fullScreenImagePath}
            onCloseRequest={() =>
              this.setState({
                isFullScreenImage: false,
                fullScreenImagePath: "",
              })
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  symbol: getCurrencySymbol(),
  isInquiry: state.settings.isInquiry,
});

export default connect(
  mapStateToProps,
  {
    counter: getCommonCounter,
    notificationCounter: getNotificationCounter,
    isInquiryOrCart: isInquiryOrCart,
  }
)(withRouter(OrderDetails));
